import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 引入全局css,会作用于所有的vue组件
// @代表项目的src文件夹
import '@/assets/css/global.scss'
//引入elementui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
// 引入字体图标库
import '@/assets/fonts/iconfont.css'
import store from '@/store/index'
// 引入rem配置
import '@/utils/rem'

import Pagination from "@/components/Pagination";
import AddToPlaylist from "@/views/components/AddToPlaylist";
import NewPlaylist from "@/views/components/NewPlaylist";
import { parseTime, formatTime, resetForm, addDateRange, handleTree } from "@/utils/neu";
import apiClient, { getAuthHeaders } from '@/utils/apiClient'
import externalClient from '@/utils/externalClient'

Vue.prototype.$http = apiClient
Vue.prototype.$apiClient = apiClient
Vue.prototype.$externalClient = externalClient
Vue.prototype.$uploadAuthHeaders = getAuthHeaders

Vue.config.productionTip = false
Vue.use(ElementUI);

// 提交以后禁用按钮一段时间，防止重复提交
Vue.directive('noMoreClick', {
  inserted(el, binding) {
    el.addEventListener('click', e => {
      el.classList.add('is-disabled')
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
        el.classList.remove('is-disabled')
      }, 2000) // 设置的是2000毫秒也就是2秒
    })
  }
})

// 全局方法挂载
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.formatTime = formatTime
Vue.prototype.addDateRange = addDateRange
Vue.prototype.handleTree = handleTree

// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('AddToPlaylist', AddToPlaylist)
Vue.component('NewPlaylist', NewPlaylist)

// 音频时长转换分秒格式
Vue.prototype.$formatTime = (time) => {
          var f = Math.floor(time / 60);
          var m = time % 60;
          f = f < 10 ? '0' + f : f;
          m = m < 10 ? '0' + m : m;
          return f + ':' + m;
}

// axios响应拦截器
// axios.interceptors.response.use(
//   response => {
//     let res = response.data;
//     //判断token是否 失效, 控制跳转
//     if (res.code == 401) {
//       alert('请先登录！')
//       router.push('/admin')
//     }
//     return response;
//   },
//   error => {
//     console.log('err' + error); // for debug
//     return Promise.reject(error);
//   }
// )

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
